/*
 * File: spacer.vue.ts
 * File Created: 2023-11-27 03:21:15
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-09-13 02:53:47
 * Modified By: Val Liu
 * -----
 */

import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class Spacer extends Vue {
    @Prop({ type: String, required: true })
    height!: string;
}
